import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="relative border-t border-white/[0.08] bg-espresso/60 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <p className="font-serif font-bold text-center leading-none tracking-tight text-[13vw] lg:text-[9rem] text-white/[0.06] select-none whitespace-nowrap">
          MODICO
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Modico Barberia" className="h-9 w-auto object-contain" />
            <div>
              <p className="font-serif text-ivory">Modico Barberia</p>
              <p className="text-[10px] font-mono uppercase tracking-widest text-stone">Atri — dal rito, al dettaglio</p>
            </div>
          </div>
          <div className="flex items-center gap-6 text-xs font-mono uppercase tracking-widest text-stone">
            <a href="tel:+393273832605" className="hover:text-ember transition-colors duration-300">
              Tel
            </a>
            <a href="mailto:danieledesanctis772@gmail.com" className="hover:text-ember transition-colors duration-300">
              Email
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Via+Cardinale+Cicada+5,+64032+Atri+TE,+Italia"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-ember transition-colors duration-300"
            >
              Maps
            </a>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-ember transition-colors duration-300">
              Area Riservata
            </Link>
          </div>
        </div>
        <p className="mt-10 text-center text-[11px] font-mono tracking-widest text-stone/70">
          © {new Date().getFullYear()} Modico Barberia — Daniele De Sanctis · Via Cardinale Cicada 5, Atri (TE) · +39 327 383 2605
        </p>
      </div>
    </footer>
  );
}
